import type { Cell } from '@vedalib/editor/lib/elements'

import type { Properties } from 'components/Editor/EditorElements/elements.types'

import type { TableElementType } from '../../tableTypes'

export const getCellStyles = ({
  cell,
  col,
  headerColumn,
  headerRow,
  row,
  styles,
}: {
  cell: Cell
  headerRow: boolean
  headerColumn: boolean
  row: number
  col: number
  styles: Properties<TableElementType>['styles'] | null
}) => {
  const isHeader = (row === 0 && headerRow) || (col === 0 && headerColumn)

  return {
    ...styles?.content,
    ...styles?.divider,
    ...(isHeader ? styles?.header : {}),
    ...styles?.indent,
    ...(cell?.color && { backgroundColor: cell?.color }),
  }
}
